import { render, staticRenderFns } from "./MatterCategoryForm.vue?vue&type=template&id=5098a3b2&scoped=true"
import script from "./MatterCategoryForm.vue?vue&type=script&lang=js"
export * from "./MatterCategoryForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=5098a3b2&prod&scoped=true&lang=css&external"
import style1 from "./MatterCategoryForm.vue?vue&type=style&index=1&id=5098a3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098a3b2",
  null
  
)

export default component.exports